export class Responsavel {
  codigoUsuario: string;
  email : string;
  login: string;
  nome: string;
  }